<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-select
            v-model="formData.group_id"
            :items="groups"
            label="المجموعة"
            item-title="name"
            item-text="description"
            item-value="id"
          >
          </v-select>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>
        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import repo from "@/store/repo.js";
export default {
  props: ["customer", "groups", "iconName", "mode"],
  data() {
    return {
      isActive: false,
      formData: {
        customer_id: "",
        group_id: "",
      },
    };
  },
  computed: {},
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();
      if (valid) {
        this.formData.customer_id = this.customer.id;
        if (this.mode == "add") {
          await repo.customers.addToGroup(this.formData);
        } else {
          await repo.customers.removeFromGroup(this.formData);
          console.log("mode=remove");
        }
        this.$emit("closed");
        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        console.log(value);
        //   if (this.mode == "edit") {
        //     this.formData = { ...this.item };
        //     this.formData.isNoCut = this.formData.isNoCut == 1 ? true : false;
        //     this.formData.isDiscount =
        //       this.formData.isDiscount == 1 ? true : false;
        //     console.log("formmmmm", this.formData);
        //   }
      }
    },
  },
};
</script>
